// Number of accounts to show before clicking option to see more.
export const INITIAL_ACCOUNT_LENGTH = 4;

export const PENDING_LINKING_DATA_KEY = "pendingAccountLinkingData";
export const CONFIRMED_LINKING_DATA_KEY = "confirmedAccountLinkingData";
export const ATTEMPTED_LINKING_DATA_KEY = "attemptedAccountLinkingData";

export const INVALID_STATE_ERROR = {
  message:
    "Account state is out of sync. Please refresh and try again (your current mappings will be saved).",
  retryable: true,
};

export interface ErrorArgs {
  error?: any;
  message?: string;
  retryable?: boolean;
}

export interface GLAccount {
  id: string;
  name: string;
  currency_code: string;
  account_type: string;
}

export interface BankFeedAccount {
  id: string;
  name: string;
  account_id?: string;
  current_balance: number | null;
  bank_account_type: string;
}

export interface BankFeedAccountLinkingData {
  bfAccountId: string;
  glAccountId: string;
  bfAccountName: string;
  glAccountName: string;
  isChecked: boolean;
}

export interface GLAccountProps {
  account_type: string;
  name?: string;
  nominal_code?: string;
  currency_code?: string;
  subsidiary_id?: string;
  additional_fields?: {
    bank_account_number: string;
  };
}

export interface Currency {
  id: string;
  currency_code: string;
  currency_name: string;
}

export interface Subsidiary {
  currency_code: string;
  platform_id: string;
  name: string;
  id: string;
  status: string;
  parent_id?: string;
}
